import axiosInstance from './ApiService';

const getAll = () => {
  return axiosInstance.get(`artikli`);
};

const getAllActiveArticles = () => {
  return axiosInstance.get(`artikli/aktivni`);
};

const get = (id) => {
  return axiosInstance.get(`artikli/${id}`);
};

const create = (article, brandName) => {
  return axiosInstance.post("artikli", article, {
    params: {
      brandName: brandName
    }
  }).then(response => {
    return response.data;
  }).catch(error => {
    throw new Error(error);
  });
};

const showArticle = (id) => {
  return axiosInstance.post("artikli/prikazi", id)  // send id directly
    .then(response => {
      return response.data;
    }).catch(error => {
      throw new Error(error);
    });
};

const hideArticle = (id) => {
  return axiosInstance.post("artikli/sakrij", id)  // send id directly
  .then(response => {
    return response.data;
  }).catch(error => {
    throw new Error(error);
  });
};

const activateArticle = (id) => {
  return axiosInstance.post("artikli/aktiviraj", id)  // send id directly
    .then(response => {
      return response.data;
    }).catch(error => {
      throw new Error(error);
    });
};

const getAllArticlesWithVisibilityForClient = (id) => {
 return axiosInstance.get(`artikli/vidljivost`, { params: { id } });
};

const hideArticlesForClient = async (requestData) => {
  try {
    console.info("SENDING REQUEST", JSON.stringify(requestData));
    const response = await axiosInstance.post('artikli/vidljivost/sakrij', requestData);
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
};

const deactivateArticle = (id) => {
  return axiosInstance.post("artikli/deaktiviraj", id)  // send id directly
  .then(response => {
    return response.data;
  }).catch(error => {
    throw new Error(error);
  });
};

const update = (id, data) => {
  // Convert string boolean values to actual booleans
  const updatedData = {
    ...data,
    isActive: data.isActive === 'true',
    isVisible: data.isVisible === 'true',
    // Convert empty strings to null for numeric fields
    quantityPerTransportPackage: data.quantityPerTransportPackage || null,
    minimumQuantityDemand: data.minimumQuantityDemand || null,
    brutoMass: data.brutoMass || null,
    wholesalePrice: data.wholesalePrice || null,
    retailPrice: data.retailPrice || null,
    pdv: data.pdv || null,
    startingQuantityDemand: data.startingQuantityDemand || null,
    maximumQuantityDemand: data.maximumQuantityDemand || null,
    minimumTemperature: data.minimumTemperature || null,
    maximumTemperature: data.maximumTemperature || null,
    expiryDateInMinutes: data.expiryDateInMinutes || null
  };
  return axiosInstance.put(`artikli/${id}`, updatedData);
};

const remove = (id) => {
  return axiosInstance.delete(`artikli/${id}`);
};

const removeAll = () => {
  return axiosInstance.delete(`artikli`);
};

const findByName = (articleName) => {
  return axiosInstance.get(`artikli/findByArticleName?articleName=${articleName}`);
};

const updateImage = (id, code, imageFile) => {
  const formData = new FormData();
  formData.append('articleImage', imageFile);
  formData.append('code', code);

  return axiosInstance.post(`/artikli/azurirajSliku/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const ArticleService = {
  getAll,
  getAllActiveArticles,
  getAllArticlesWithVisibilityForClient,
  hideArticlesForClient,
  get,
  create,
  update,
  remove,
  removeAll,
  findByName,
  activateArticle,
  deactivateArticle,
  showArticle,
  hideArticle,
  updateImage
};

export default ArticleService;
